import { Link, useParams } from "react-router-dom";
import { useState } from "react";

export const DebateTopicHeader = ({ searchKeyword = (f) => f }) => {
    const { school } = useParams();
    const [keyword, setKeyword] = useState();

    return (
        <div className="debateHeader">
            <div className="inner">
                <div>
                    <div className="in_header">
                        <Link to={`/${school}/debate`}>
                            <img className="title_pc"
                                src={`${process.env.PUBLIC_URL}/static/images/debate_topic_list/debate_topic_list_title_pc.png`}
                                alt="응답하라 독서토론 주제목록"
                            />
                            <img className="title_mo"
                                src={`${process.env.PUBLIC_URL}/static/images/debate_topic_list/debate_topic_list_title_mo.png`}
                                alt="응답하라 독서토론 주제목록"
                            />
                        </Link>
                        <div className="search_area">
                            <form onSubmit={(e) => searchKeyword(e, keyword)}>
                                <input
                                    type="text"
                                    name="searchKeyword"
                                    className="search_input"
                                    placeholder="👀 다양한 독서 토론 주제를 검색해보세요."
                                    autoComplete="off"
                                    onChange={(e) => setKeyword(e.target.value)}
                                />
                                <button type="submit" className="search_btn"></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};